import { useEffect, useState, useCallback } from "react";
import { fetchPackages } from "../services/api";

export function usePackages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPackages();
      setPackages(data);
    } catch (err) {
      setError(err.message || "Error cargando paquetes");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { packages, loading, error, refetch: load };
}
